"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notificationDropdown = (0, _glamor.css)({
  color: _css.colors.gray,
  paddingTop: "" + (0, _css.unitRem)(0.75)
});

var heading = (0, _glamor.css)({
  color: _css.colors.gray,

  fontSize: (0, _css.unitRem)(0.625),
  fontWeight: 600,

  textTransform: "uppercase",

  paddingLeft: (0, _css.unitRem)(1),
  paddingBottom: (0, _css.unitRem)(0.75),
  borderBottom: "1px solid " + _css.colors.medLightGray
});

var notificationsList = (0, _glamor.css)(_css.noListStyle, {
  width: "100%",
  maxHeight: "430px",
  overflowY: "scroll"
});

var notification = function notification(isNew) {
  return (0, _glamor.css)({
    padding: (0, _css.unitRem)(0.66),

    borderBottom: "1px solid " + (isNew ? _css.colors.medDarkGray3 : _css.colors.medLightGray),
    whiteSpace: "nowrap",

    background: isNew ? _css.colors.medLightGray : ""
  });
};

var notifIcon = function notifIcon(notif) {
  return (0, _glamor.css)({
    display: "inline-block",
    verticalAlign: "middle",

    width: (0, _css.unitRem)(2.66),
    height: (0, _css.unitRem)(2.66),
    borderRadius: !!notif.iconUrl && notif.iconUrl.length ? "50%" : "0px",
    marginRight: (0, _css.unitRem)(0.75),
    // backgroundImage: 'notif.iconUrl || '/megascans_logo_small.png''
    backgroundImage: !!notif.iconUrl ? "url(\"" + notif.iconUrl + "\")" : "url(\"/megascans_logo_small.png\")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "50%"
  });
};

var notifBody = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
});

var notifTitleStyle = function notifTitleStyle(isLink, isNew) {
  return (0, _glamor.css)({
    display: "block",
    fontSize: (0, _css.unitRem)(0.625),
    fontWeight: 400,

    color: isLink ? _css.colors.blue : isNew ? "#999" : "#777",
    maxWidth: "200px",
    whiteSpace: "normal",
    maxHeight: "calc(0.9375em*2 + 4px)",
    textOverflow: "ellipsis",
    overflow: "hidden",
    marginBottom: (0, _css.unitRem)(0.35),
    paddingBottom: "3px"
  });
};
var notifText = function notifText(isNew) {
  return (0, _glamor.css)({
    display: "block",
    fontSize: (0, _css.unitRem)(0.6),
    fontWeight: 400,
    color: isNew ? "#777" : "#555",
    maxWidth: "100px",
    whiteSpace: "normal",
    maxHeight: "calc(0.9375em*3 + 3px)",
    textOverflow: "ellipsis",
    overflow: "hidden",
    paddingBottom: (0, _css.unitRem)(0.1),
    marginBottom: (0, _css.unitRem)(0.2)
  }, (0, _css.minWidth)(_css.breakpoints.small)({
    maxWidth: "170px"
  }), (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
    maxWidth: "200px"
  }));
};

var notifTime = (0, _glamor.css)({
  display: "block",
  fontSize: (0, _css.unitRem)(0.6),
  fontWeight: 400,
  color: "#555"
});

function onMouseWheel(e) {
  var delta = e.deltaY;
  var scrollElement = e.currentTarget;
  var scrollPos = scrollElement.scrollTop;
  var maxScroll = scrollPos + scrollElement.clientHeight;
  var scrollHeight = scrollElement.scrollHeight;

  if (scrollPos === 0 && delta < 0 || maxScroll >= scrollHeight && delta > 0) {
    e.preventDefault();
    e.stopPropagation();
  }
}

var renderNotificaion = function renderNotificaion(notif, i) {
  var notifTitle = notif.message.trim();
  var notificaionText = notif.text.trim();
  var notificaionTitleStyle = {};
  var notificaionTextStyle = {};

  if (notifTitle && notifTitle.length && notificaionText && notificaionText.length) {
    notificaionTitleStyle.whiteSpace = "nowrap";
    notificaionTitleStyle.marginBottom = "0.1em";
    notificaionTextStyle.maxHeight = "calc(2.3em + 3px)";
    notificaionTextStyle.lineHeight = "1.2";
  }
  return _react2.default.createElement(
    "li",
    (0, _extends3.default)({}, notification(notif.isNew), { key: "notif-" + i }),
    _react2.default.createElement("div", notifIcon(notif)),
    _react2.default.createElement(
      "div",
      notifBody,
      notifTitle && _react2.default.createElement(
        "span",
        (0, _extends3.default)({}, notifTitleStyle(notif.action && notif.action.uri, notif.isNew), {
          style: notificaionTitleStyle
        }),
        notifTitle
      ),
      notificaionText && _react2.default.createElement(
        "span",
        (0, _extends3.default)({}, notifText(notif.isNew), { style: notificaionTextStyle }),
        notificaionText
      ),
      _react2.default.createElement(
        "span",
        notifTime,
        notif.time
      )
    )
  );
};

var NotificationDropdown = function (_React$Component) {
  (0, _inherits3.default)(NotificationDropdown, _React$Component);

  function NotificationDropdown(props) {
    (0, _classCallCheck3.default)(this, NotificationDropdown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationDropdown.__proto__ || (0, _getPrototypeOf2.default)(NotificationDropdown)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(NotificationDropdown, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(event) {
      // console.log('the scroll things', event)
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener("scroll", this.handleScroll);

      var rerenderTimer = setInterval(function () {
        _this2.forceUpdate();
      }, 30000);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        "div",
        (0, _extends3.default)({ id: "excuse" }, notificationDropdown),
        _react2.default.createElement(
          "div",
          (0, _extends3.default)({ id: "sfdzfc" }, heading),
          "Notifications"
        ),
        _react2.default.createElement(
          "ul",
          (0, _extends3.default)({}, notificationsList, { onWheel: onMouseWheel }),
          props.notifications.map(function (notif, i) {
            if (notif.assetIds) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: props.onClick ? null : "/megascans/library?filter=" + notif.assetIds.join("|"),
                    onClick: function onClick() {
                      props.onClick ? props.onClick(notif) : null;
                    },
                    key: i
                  },
                  renderNotificaion(notif, i)
                )
              );
            }

            return notif.action && notif.action.uri ?
            // eslint-disable-next-line react/no-array-index-key
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: props.onClick ? null : notif.action.uri,
                target: notif.action.target,
                onClick: function onClick() {
                  props.onClick ? props.onClick(notif) : null;
                },
                key: i,
                rel: notif.action.target && "noreferrer"
              },
              renderNotificaion(notif, i)
            ) : renderNotificaion(notif, i);
          })
        )
      );
    }
  }]);
  return NotificationDropdown;
}(_react2.default.Component);

exports.default = NotificationDropdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationDropdown/NotificationDropdown.jsx
// module id = 2601
// module chunks = 0